import { Schema } from "mongoose"
import { z } from "zod"

import type { AclPolicy } from "../acl"


export const ZRBNotificationDigestFrequency = z.enum(["off", "daily", "weekly"])

export const ZRBNotificationTopicPreference = z.object({
  topic: z.string(),
  inApp: z.boolean(),
  emailDigest: z.boolean(),
  push: z.boolean(),
})

export const ZRBNotificationSettings = z.object({
  userId: z.string(),
  digestFrequency: ZRBNotificationDigestFrequency,
  topicPreferences: z.array(ZRBNotificationTopicPreference).optional(),
  lastDigestSentAt: z.date().optional(),
})

export type IRBNotificationSettings = z.infer<typeof ZRBNotificationSettings>

const TopicPreferenceSchema = new Schema(
  {
    topic: { type: String, required: true },
    inApp: { type: Boolean, required: true, default: true },
    emailDigest: { type: Boolean, required: true, default: true },
    push: { type: Boolean, required: true, default: false },
  },
  { _id: false },
)

export const RBNotificationSettingsSchema: Schema = new Schema(
  {
    userId: { type: String, required: true },
    digestFrequency: {
      type: String,
      required: true,
      enum: ZRBNotificationDigestFrequency.options,
      default: "weekly",
    },
    topicPreferences: {
      type: [TopicPreferenceSchema],
      default: [],
    },
    lastDigestSentAt: { type: Date, required: false },
  },
  {
    versionKey: false,
    timestamps: true,
  },
)

RBNotificationSettingsSchema.index({ userId: 1 }, { unique: true })
RBNotificationSettingsSchema.index({ userId: 1, "topicPreferences.topic": 1 })

export const RBNotificationSettingsPolicy: AclPolicy = {
  subject: "RBNotificationSettings",
  define: (builder, ctx) => {
    if (!ctx.userId) return
    builder.can("create", "RBNotificationSettings")
    builder.can("read", "RBNotificationSettings", { userId: ctx.userId })
    builder.can("update", "RBNotificationSettings", { userId: ctx.userId })
  },
}
